import React from 'react'
import { MarkupLayout } from "../../ui/markupLayout/MarkupLayout"
import { Heading } from "../../ui/heading/Heading"
import styles from "./uniqueCardSection.module.css"
import { Button } from "../../ui/button/Button"
export function UniqueCardSection() {


  const mockData = [
    {
      text: "Дисковые колодки",
      img: "/images/brake2.webp",
      link: "discpads",
    },
    {
      text: "Барабанные колодки",
      img: "/images/brake1.webp",
      link: "drumpads",
    }
  ]
  return (
    <section className={styles.uniqueCardSection}>
      <MarkupLayout>
        <Heading color={"white"}>Тормозные колодки</Heading>
        <div className={styles.cardContainer}>
          {mockData.map((item) => {
            return (
              <div key={item.text} className={styles.cardHolder}>

                <img loading='lazy' className={styles.cardImg} src={item.img} alt={item.text} />

                <Button variant={"yellow"} behaviour="link" link={`/brake-pads/${item.link}`}>{item.text}</Button>
              </div>
            )
          })}
        </div>
      </MarkupLayout>
    </section>
  )
}
